import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleInput from "../../../../../modules/SimpleInput";
import Api from "../../../../../Services/Api";
import {
  contructQueryParam,
  fetchDataAsync,
} from "../../../../../Services/Utils";
import { HttpStatus, INITIAL_PAGINATION } from "../../../../common/Constants";
import {
  autoPopulateSelectBooking,
  constructGetDataModalCustomer,
} from "../../utils";
import { modalCustomerTableConfig } from "./config";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class ModalCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      searchValue: null,
      keyword: null,
      pagination: INITIAL_PAGINATION,
    };
  }

  componentDidMount() {
    const { pagination } = this.state;
    this.fetchData(pagination.limit, pagination.page);
  }

  componentDidUpdate(prevProps, prevState) {
    const currPagination = this.state.pagination;
    const prevPagination = prevState.pagination;

    if (
      currPagination.page !== prevPagination.page ||
      currPagination.limit !== prevPagination.limit || this.state.keyword !== prevState.keyword
    ) {
      this.fetchData(currPagination.limit, currPagination.page);
    }
  }

  fetchData = async (limit, page) => {
    const { setError, onTriggerLoading } = this.props;
    const { keyword } = this.state;

    onTriggerLoading();
    const res = await await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getListCustomerForSalesOrder,
      setError: setError,
      menuName: "Faktur Jual - Data Unit",
      args: contructQueryParam({
        customerName: keyword || "",
        limit: limit || 5,
        page: page || 1,
      }),
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data?.map((item) =>
          constructGetDataModalCustomer(item)
        ),
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData || 0,
        },
      }));
    }
  };

  handleSelectBooking = (rowIndex) => {
    const { dataTable } = this.state;
    const { setValue, onClickClose } = this.props;
    autoPopulateSelectBooking({
      data: dataTable[rowIndex],
      setValue: setValue,
    });
    onClickClose();
  };

  getTableColumns = () => {
    return modalCustomerTableConfig({
      onSelect: this.handleSelectBooking,
    });
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { searchValue, dataTable, pagination } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="List Data Customer / Member"
          visible={visible}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <FlexView vAlignContent="center">
                <h4 className="txt-site txt-11 txt-main txt-bold margin-bottom-20px">
                  Nama Customer
                </h4>
                <SimpleInput
                  id="consumenName"
                  placeholder="Nama Konsumen"
                  value={searchValue}
                  containerclassname="width width-250px margin-left-10px"
                  onChange={({ target }) =>
                    this.setState({ searchValue: target.value })
                  }
                />
                <SimpleButton
                  id="btn_consumen_name"
                  className="margin-bottom-20px"
                  text="Cari"
                  onClick={() => this.setState({
                    keyword: searchValue
                  })}
                />
              </FlexView>
              <SimpleDataTable
                data={dataTable}
                columns={this.getTableColumns()}
                toCount={pagination.totalData}
                rowsPerPage={pagination.limit}
                page={pagination.page - 1}
                options={defaultTableChange(
                  this.handleChangePage,
                  this.handleRowsPerPage
                )}
              />
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default ModalCustomer;
